import React, { useContext, useState } from 'react';
import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import classnames from 'classnames';

import { useTranslation } from '@common/hooks/translation';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { Logout } from '@app/dev/actions/login';
import Config from '@app/dev/config/main';
import IdleService from '@common/services/idle';
import NumericInput from '@common/components/numericInput';
import { formatCpfNumber, getOriginalCpf } from '@app/dev/helpers/formatCpfNumber';
import ToastWrapper from '@common/helpers/toastWrapper';
import { POPUPS } from '@common/constants/popups';
import { PopupContext } from '@app/dev/contexts/popup';
import { makeLogin } from "@app/dev/helpers/login";

import './style.scss';

const SignIn = ({ cpf = '' }) => {
  const t = useTranslation();
  const dispatch = useDispatch();
  const [{ openPopup, closePopup }] = useContext(PopupContext);
  const [form, setForm] = useState({
    cpf,
    pin: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const onSignIn = async () => {
    setLoading(true);

    const formErrors = {};

    if (!form.cpf) formErrors.cpf = 'Field is required';
    if (form.cpf && form.cpf.length !== 14) formErrors.cpf = 'Invalid format';
    if (!form.pin) formErrors.pin = 'Field is required';

    if (!isEmpty(formErrors)) return setErrors(formErrors);

    try {
      const authData = JSON.parse(window.sessionStorage.getItem('authData'));

      const originalCpf = getOriginalCpf(form.cpf);

      const data = await swarmRequest(
        {
          pin: form.pin,
          card_number: originalCpf,
          cashdesk: authData.tid,
        },
        'rfid_login',
      );

      if (data?.user_id) {
        makeLogin({ authData: data, rfid: originalCpf, loggedInByRFID: true });

        ToastWrapper('success', 'You have successfully signed in');

        if (Config.rfid.logoutIfIdleSecondsCount) {
          IdleService.ifInactive(Config.rfid.logoutIfIdleSecondsCount, () => {
            dispatch(Logout(true));
            closePopup();
          });
        }

        closePopup();
      } else {
        setErrors({ pin: 'WRONG CPF NUMBER OR PIN CODE' });
      }
    } catch (ex) {
      setErrors({ pin: 'WRONG CPF NUMBER OR PIN CODE' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('sign-in')}</h3>

      <div className="popup-main-content">
        <div className="input-wrapper">
          <p className="popup-txt">{t('CPF NUMBER')}</p>
          <div className="input-row">
            <NumericInput
              className="sup-input"
              onChange={(val) => setForm({ ...form, cpf: formatCpfNumber(val) })}
              value={form.cpf}
              customFormat
            />
          </div>
          {errors.cpf && (
            <div className="error-row" style={{ display: '' }}>
              <i className="global-icon icon-toast-error error-icon-cont" />
              <p className="error-row-text">{t(errors.cpf)}</p>
            </div>
          )}
          <p className="popup-txt">{t('PIN')}</p>
          <div className="input-row">
            <NumericInput
              className="sup-input"
              onChange={(val) => setForm({ ...form, pin: val })}
              value={form.pin}
              maxLength={4}
              type="password"
            />
          </div>
        </div>
        {errors.pin && (
          <div className="error-row" style={{ display: '' }}>
            <i className="global-icon icon-toast-error error-icon-cont" />
            <p className="error-row-text">{t(errors.pin)}</p>
          </div>
        )}
        <div onClick={() => openPopup(POPUPS.FORGOT_PASSWORD, { cpf: form.cpf })}>
          <p className="row-forgot-text">{t('Reset Pin')}</p>
        </div>
      </div>

      <div className="popup-actions">
        <button type="button" onClick={closePopup} className="popup-cancel-button">
          {t('Close')}
        </button>
        <button
          type="button"
          onClick={onSignIn}
          className={classnames('popup-confirm-button', { disabled: loading })}
        >
          {t('Sign In')}
        </button>

      </div>
      <div className="row-registration">
        <p>{t("Don't have an account?")}</p>
        <p className="text" onClick={() => openPopup(POPUPS.SIGN_UP)}>
          {t('Register')}
        </p>
      </div>
    </div>
  );
};

export default SignIn;
